import styled from 'styled-components';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

export const Footer = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
  noPrint: true,
})`
  width: 100%;
  min-height: 52px;
  border-top: 1px solid #ededed;
  background: #fafafa;
  border-radius: 0 0 10px 10px;
  padding: 0 10px;
`;

export const Add = styled(Flex).attrs({
  align: 'center',
})`
  width: 25px;
  height: 25px;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`;

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    stroke: props.theme.colors.primary,
  }),
)``;

export const Search = styled(Flex).attrs({
  fillSpace: true,
  align: 'center',
})`
  position: relative;
  z-index: 9;

  & > div {
    width: 100%;
  }
`;

export const Label = styled(Text)`
  color: ${props => props.theme.colors.primary};
`;
